/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

// Routes
import paths from './paths'

// Store
import store from '@/store'
import { loadLanguageAsync } from '../i18n'

function route (path, view, name, meta) {
  return {
    name: name || view,
    path,
    component: (resolve) => import(`@/views/${view}.vue`).then(resolve),
    meta: meta
  }
}

Vue.use(Router)
Vue.use(Meta)

// Create a new router
const router = new Router({
  mode: 'hash',
  base: '/public/',
  routes: paths.map(path => route(path.path, path.view, path.name, path.meta)).concat([
    { path: '*', redirect: '/tankstatus' }
  ]),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  var lang = ''
  if (localStorage.currentLanguage) {
    lang = localStorage.currentLanguage
  } else {
    lang = router.app.$i18n.locale
  }
  loadLanguageAsync(lang, router.app).then(() => {
    if (to.name === 'LandingPage') {
      store
        .dispatch('logout')
        .then(() => {
          next()
        })
    }
    if (to.matched.some(record => record.meta.anonymous)) {
      next()
    } else {
      if (store.getters.isLoggedIn) {
        next()
      } else {
        next('/landingpage')
      }
    }
  })
})

export default router
